import useMembership from 'src/hook/useMembership'
import useSendDataHubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import { Actions, ScreenNames } from 'src/utils/datahub/enums'
import { CommunitySurveySendEventProps } from './useCommunitySurveySendEvent.types'

const useCommunitySurveySendEvent = () => {
  const { membership } = useMembership()
  const { sendDataHubConsume } = useSendDataHubConsume()
  const { community } = useCommunityDetails()

  const communitySurveySendEvent = ({
    userResponse,
    entity,
    eventName,
    surveyName
  }: CommunitySurveySendEventProps) => {
    sendDataHubConsume({
      entity,
      action: Actions.ANSWER,
      event: {
        eventName,
        screenName: ScreenNames.COMMUNITY_FEED,
        surveyName,
        communityId: community.id,
        communityName: community.name,
        membershipId: membership?.id,
        ...userResponse
      }
    })
  }

  return { communitySurveySendEvent }
}

export default useCommunitySurveySendEvent
